import { Typography, PrimaryButton, ChannelIcon } from '@weareopenr/component-library';
import styles from './NoChannelsView.module.scss';

export const NoChannelsView = () => {
  const onAdminClick = () => {
    const adminUrl = window.location.origin.replace('hub', 'admin');
    window.location.assign(adminUrl);
  };
  return (
    <div>
      <div className={styles.icon}>
        <ChannelIcon size="xlarge" />
      </div>
      <Typography size="xxlarge" weight="semi-bold" className={styles.title}>
        Publish unavailable
      </Typography>
      <Typography size="medium" className={styles.subtitle}>
        Go to Admin to enable channels and/or create venues in order to publish
      </Typography>
      <PrimaryButton size="full-width" onClick={onAdminClick}>
        Go to Admin
      </PrimaryButton>
    </div>
  );
};
